import React, { useEffect } from "react";
import { Route, Switch } from "react-router";
import { connect } from "react-redux";

import LoggedInContainer from "web_modules/shared/LoggedInContainer";
import { loadSettlementAgentSearchData } from "web_modules/redux/searchLoans/actions";
import { getSessionToken } from "web_modules/shared/session";
import AppView from "./AppView";
import Homepage from "./Homepage";

const styles = require("./styles.module.scss");

const navPaths = {
  root: "/settlement-agent",
};

interface Props {
  loadSearchData: any;
}

const SettlementAgentDashboard: React.FC<Props> = ({ loadSearchData }) => {
  useEffect(() => {
    if (getSessionToken()) {
      loadSearchData();
    }
  }, [loadSearchData]);

  return (
    <div className={styles.container}>
      <LoggedInContainer
        titleLink={{
          name: "Settlement Agent",
          to: navPaths.root,
        }}
      >
        <Switch>
          <Route exact path="/settlement-agent" component={() => <Homepage />} />
          <Route exact path="/settlement-agent/app/:id" render={props => <AppView {...props} />} />
        </Switch>
      </LoggedInContainer>
    </div>
  );
};

export default connect(
  null,
  { loadSearchData: loadSettlementAgentSearchData },
)(SettlementAgentDashboard);
